/** Ein Blatt von unten. Schliesst mit Escape, mit einem Tipp daneben und
 *  mit dem Knopf: drei Wege, weil auf dem Handy jeder davon der erste ist,
 *  den jemand probiert. */
import { useEffect, useRef, type ReactNode } from 'react'

import { useLang } from '../lang'

export function Sheet({
  title,
  children,
  onClose,
  dismissible = true,
}: {
  title: string
  children: ReactNode
  onClose: () => void
  dismissible?: boolean
}) {
  const { t } = useLang()
  const box = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && dismissible) onClose()
    }
    document.addEventListener('keydown', onKey)
    box.current?.focus()
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose, dismissible])

  return (
    <div
      className="sheet"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={(e) => {
        if (dismissible && e.target === e.currentTarget) onClose()
      }}
    >
      <div className="sheet__inner" ref={box} tabIndex={-1}>
        <div className="row row--between" style={{ marginBottom: 10 }}>
          <h2>{title}</h2>
          {dismissible ? (
            <button type="button" className="btn btn--ghost" onClick={onClose}>
              {t('common.close')}
            </button>
          ) : null}
        </div>
        {children}
      </div>
    </div>
  )
}
